// Centralised web-session storage. The token + identity are written here by
// the QR login flow (Phase 0) and read by the API client, socket, and the
// /app route guard.

const TOKEN_KEY = 'webToken';
const USER_ID_KEY = 'webUserId';
const USER_NAME_KEY = 'webUserName';
const QR_TOKEN_KEY = 'webQrToken';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUser() {
  const userId = localStorage.getItem(USER_ID_KEY);
  if (!userId) return null;
  return {
    userId,
    userName: localStorage.getItem(USER_NAME_KEY) || null,
    qrToken: localStorage.getItem(QR_TOKEN_KEY) || null,
  };
}

export function saveSession({ token, userId, userName, qrToken }) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  if (userId) localStorage.setItem(USER_ID_KEY, userId);
  if (userName) localStorage.setItem(USER_NAME_KEY, userName);
  if (qrToken) localStorage.setItem(QR_TOKEN_KEY, qrToken);
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_ID_KEY);
  localStorage.removeItem(USER_NAME_KEY);
  localStorage.removeItem(QR_TOKEN_KEY);
}

export function isAuthenticated() {
  return Boolean(getToken() && localStorage.getItem(USER_ID_KEY));
}
